var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBahtSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.734 238.246C281.812 221.061 288 201.322 288 180C288 117.4 238.078 66.566 176 64.404V32C176 14.312 161.688 0 144 0S112 14.312 112 32V64H40C17.906 64 0 81.906 0 104V408C0 430.094 17.906 448 40 448H112V480C112 497.688 126.312 512 144 512S176 497.688 176 480V448H204C267.969 448 320 395.969 320 332C320 293.379 300.844 259.342 271.734 238.246ZM208 180C208 198.426 193.879 213.104 176 215.189V144.811C193.879 146.896 208 161.574 208 180ZM80 144H112V216H80V144ZM80 368V296H112V368H80ZM204 368H176V296H204C223.844 296 240 312.156 240 332S223.844 368 204 368Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBahtSign);
export default __webpack_public_path__ + "static/media/baht-sign.5b15f0fa7038fa2e22272393d58b69e2.svg";
export { ForwardRef as ReactComponent };